import React, {useEffect} from "react";
import "../../Stylesheets/index.css";
import LeftNavbar from "./leftNavbar";
import {useDispatch, useSelector} from "react-redux";
import PartnerPortalHeaderWithBtn from "./partnerPortalHeaderWithBtn";
import DashboardWrapper, {DASHBOARD_COMPONENT} from "../Dashboard/dashboardWrapper";
import BillingPageWrapper, {BILLING_COMPONENT} from "../Billing/billingPageWrapper";
import EarningPageWrapper, {EARNING_COMPONENT} from "../Earning/earningPageWrapper";
import ProfilePageWrapper, {PROFILE_COMPONENT} from "../Profile/profilePageWrapper";
import PaymentsWrapper, {PAYMENT_COMPONENT} from "../Payments/paymentsWrapper";
import {getAccountsDetails} from "../../Actions/partnerAccountsAction";
import {getPartnerDetails} from "../../Actions/partnerDetailsAction";
import {getPartnerBillingDetails} from "../../Actions/partnerBillingDetailsAction";
import {getPartnerInvoices} from "../../Actions/partnerInvoiceAction";
import {GetPartnerCardDetails} from "../../Actions/partnerCardInfoDetailsAction";
import PayoutsWrapper, {PAYOUTS_COMPONENT} from "../Payouts/payoutsWrapper";
import PartnerCodeAndLinksWrapper, {PARTNER_CODE_AND_LINK_COMPONENT} from "../partnerCodeAndLinks/partnerCodeAndLinksWrapper";
import UsageWrapper, {USAGE_COMPONENT} from "../Usage/usageWrapper";
import getPartnerThirdPartyBillingDetails from "../../Actions/partnerThirdPartyBillingDetailsAction";
import {getACHBankInfo} from "../../Actions/achBankInfoAction";
import {getPayoutInfo} from "../../Actions/payoutBankInfoAction";
import {getPartnerPayoutInfo} from "../../Actions/partnerPayoutsAction";
import useHandleQuerySource from "../Hook/useHandleQuerySource";
import { getPaypalInfo } from "../../Actions/paypalInfoAction";
import { getPaypalIdentity } from "../../Actions/paypalIdentityAction";
import TopBanner from "../TopBanner/topBanner";
import { getLastMonthBilling } from "../../Actions/lastMonthBillingAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { partnerActiveSelector } from "../../Reducers/partnerActiveReducer";

const PartnerPortalWrapper = () => {
    const sideBarActive = useSelector(state => state.leftSideBarActive);
    const selectedComponent = useSelector(state => state.selectedComponent);
    const partnerActive = useSelector(partnerActiveSelector)
    const history = useHistory();
    
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getPartnerDetails());
        dispatch(getAccountsDetails());
        dispatch(getPartnerBillingDetails());
        dispatch(getPartnerInvoices());
        dispatch(GetPartnerCardDetails());
        dispatch(getPartnerThirdPartyBillingDetails());
        dispatch(getACHBankInfo());
        dispatch(getPayoutInfo());
        dispatch(getPartnerPayoutInfo());
        dispatch(getPaypalInfo());
        dispatch(getPaypalIdentity());
        dispatch(getLastMonthBilling());
    }, []);

    useEffect(() => {
        if (partnerActive !== null) {
            if (!partnerActive.active)
                history.push("/partner-portal/welcome");
        }
    }, [partnerActive, history])

    const getSelectedComponent = () => {
        switch (selectedComponent.component) {
            case DASHBOARD_COMPONENT:
                return <DashboardWrapper/>
            case BILLING_COMPONENT:
                return <BillingPageWrapper/>
            case EARNING_COMPONENT:
                return <EarningPageWrapper/>
            case USAGE_COMPONENT:
                return <UsageWrapper/>
            case PAYMENT_COMPONENT:
                return <PaymentsWrapper/>
            case PROFILE_COMPONENT:
                return <ProfilePageWrapper/>
            case PARTNER_CODE_AND_LINK_COMPONENT:
                return <PartnerCodeAndLinksWrapper/>
            case PAYOUTS_COMPONENT:
                return <PayoutsWrapper/>
            default:
                return <DashboardWrapper/>
        }
    }

    useHandleQuerySource();

    return (
        <div class="partner-portal-wrapper">
            <TopBanner />
            <div>
                <LeftNavbar/>
                <div className={`container-fluid overflow-auto mainContainer ${sideBarActive ? "activeCont" : ""}`}>
                    <PartnerPortalHeaderWithBtn/>
                    <div className="content-body">
                        {getSelectedComponent()}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PartnerPortalWrapper;
